/* eslint-disable no-unused-vars */
export const partNumber = 'The part number is a unique identifier of a part (e.g. your circuit board). Its purpose is to simplify referencing to that circuit board';

export const revision = 'One or more letters or numbers';

export const quantities = 'List the number of individual board quantities to be quoted. Do not use array quantity';

export const numberOfLayers = 'The number of layers your PCB has';

export const boardSize = 'Board measurements (in inches)';

export const boardLength = 'Board Length in inches';

export const boardWidth = 'Board Width in inches';

export const materialType = 'Different types of laminate available for PCB fabrication';

export const materialThickness = 'The total thickness of the board including all plating and final finishes';

export const finishPlating = 'Plating finish that will be deposited over the copper';

export const copperInner = 'Number of ounces of copper per square foot on inner layers';

export const copperOuter = 'Number of ounces of copper per square foot on outer layers';

export const copperWeight = 'Number of ounces of copper per square foot on both outer and inner layers';

export const soldermask = 'Select what sides of the PCB to mask and what color to use to cover the PCB';

export const soldermaskColor = 'Select what color to use to cover the PCB';

export const silkscreen = 'Color of ink printed on the board. Typically white';

export const silkscreenColor = 'Color of ink printed on the board. Typically white';

export const stencilSide = 'A printed circuit board has a top and a bottom side. If you need to print (add paste) on the top side of the board, select “Top Side”.  If you need to print on the bottom side of the board, select “Bottom Side”. If you need both sides of the board to be on the same stencil, select "Combine Top and Bottom"';

export const arrayX = 'PCB Array/Panel length in inches';

export const arrayY = 'PCB Array/Panel width in inches';

export const arrayUp = 'Total number of boards per PCB Array/Panel';

export const arrayXqty = 'Number of boards along the X-axis';

export const arrayYqty = 'Number of boards along the Y-axis';

export const arraySpacingX = 'Spacing between boards on the X-axis';

export const arraySpacingXTabRouted = 'Spacing between boards on the X-axis and between boards and rails';

export const arraySpacingY = 'Spacing between boards on the Y-axis';

export const arraySpacingYTabRouted = 'Spacing between boards on the Y-axis and between boards and rails';

export const arrayRailsTop = '';

export const arrayRailsBottom = '';

export const arrayRailsLeft = '';

export const arrayRailsRight = '';

export const tabRout = 'Tabs routed between each PCB for break-a-way. Unless otherwise noted, we use 100 mil spacing between boards';

export const scoring = 'V-groove cut into both the top and bottom of the boards for break-a-way';

export const goldFingers = 'Number of gold fingers on one side of the PCB';

export const goldThickness = 'Select one of the gold thickness listed';

export const pitch = 'Minimum distance between pad centers';

export const minTraceSpace = 'Minimum trace width and spacing';

export const blindBuriedHole = '';

export const smallestHoleSize = 'Smallest finished hole in mils';

export const platedSlots = 'Elongated holes used for component placement plated with copper';

export const counterbores = 'A larger hole concentric with a smaller hole at a defined depth';

export const blindSlot = '';

export const platedEdges = 'Edges of the board itself plated with copper';

export const countersinks = 'A beveled hole opening allowing a screw head to fit flush with the surface';

export const controlledDielectric = 'Specified thickness of the insulating layers between a signal and power or ground planes';

export const controlledImpedance = '';

export const numberOfCounterboreHoles = 'A larger hole concentric with a smaller hole at a defined depth';

export const numberOfCountersinkHoles = 'A beveled hole opening allowing a screw head to fit flush with the surface';

export const goldFingersBoothSide = '';

export const ulCertification = '';

export const dataCode = '';

export const panelApproval = '';

export const bomLineItems = 'This is the number of different part numbers used on your PCB assembly. In other words, if you send us a box with all of  the parts, how many different bags will there be? In most cases,  this is the number of line items in your Bill of Materials (BOM). For example, a 10k resistor and a 1k resistor would be considered  2 Manufacturer part #s and a 20k resistor used at 4 different  locations, R6, R7, R11 and R15, would be considered as one  Manufacturer part #';

export const smtPlacements = 'The total number of surface mount parts to be placed on  the board (Example: 0805 resistor or TSOP chip). This count should  not include any parts listed below in the Fine Pitch, thru-hole  or BGA/QFN/Leadless boxes';

export const thruHolePlacements = 'The total number of thru-hole parts. (Example: Axial  leaded resistor). Note that thru-hole connectors count as one  each, regardless of the number of pins they have';

export const bgaPlacements = 'BGA (Ball Grid Array device). These are surface mount  devices with all interconnects or solder joints under the device.  We do 100% post assembly X-ray inspection of all leadless solder  joints';

export const qfnPlacements = 'QFN (Quad Flat-pack no leads). These are surface  mount devices with all interconnects or solder joints under the device.  We do 100% post assembly X-ray inspection of all leadless solder  joints';

export const doubleSideSmt = 'Are there surface mount components on both  sides of your PCB?';

export const doubleSideTHT = 'Are there through hole components on both sides of your PCB?';

export const leadFreeProcessing = 'Do you need lead-free RoHS (Reduction of Hazardous  Substances) processing? If so, we will build your assembly with  fully RoHS compliant process and supplies';

export const class3Inspection = 'Class III describes the inspection level that is performed  on your assembled PCBs. IPC 610 states that Class 2 is standard  commercial level inspection and Class 3 is an enhanced level  intended for high reliability applications. PCB Assembly Express  inspects to Class 2 by default and will inspect to Class 3 upon  request and for an additional fee';

export const zipFile = 'Gerber or DXF';

export const viaFill = '';

export const flaps = 'Flaps help make the foil more rigid and keep the paste on the stencil. Select “Yes” if you would like to be able to fold up the edges of the stencils on 2 or 3 sides.';

export const stencilAlignment = 'Please select “Center” if you want the print area (the area with the apertures) to be centered on the stencil. Please select “Offset” if you want us to use the whole board as reference for the alignment or if you need a custom alignment';

export const stencilFiducialData = 'Fiducials are marks used to align the stencil with the board. A stencil printer with visual system usually needs the fiducials to be &quot;half etched on the board side&quot;. To manually align the stencil with the circuit board you can use fiducials that are &quot;etched through&quot; or even SMT pads on the boards.';

export const stencilApproxSize = '';

export const stencilFrameType = 'e.g. QTS, ZelFlex, N/A';

export const stencilPrinterName = '';
